import React from 'react';
import { allResources } from '../data/resources';
import { packComposition } from '../data/pendingContent';
import { siteConfig } from '../data/siteConfig';
import { CoverPending } from './CoverPending';
export function Offer() {
  const ctaClass = 'inline-flex w-full justify-center text-center whitespace-normal rounded-full bg-berry-deep px-6 py-4 text-base font-semibold text-white shadow-soft transition-colors duration-200';
  return <section id="pakket" aria-labelledby="offer-title" className="scroll-mt-16 bg-plum-soft px-5 sm:px-8 py-16 sm:py-24" data-id="element-170" data-mp="tzd7iokhbmdk">
      <div className="max-w-5xl mx-auto" data-id="element-171" data-mp="p24pqp38tkcu">
        <h2 id="offer-title" className="font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-plum text-center text-balance" data-id="element-172" data-mp="13xaw5d693l6p">
          Je volgende creatieve project begint hier.
        </h2>

        <div className="mt-10 sm:mt-14 grid md:grid-cols-[1.25fr_1fr] rounded-[2rem] bg-cream overflow-hidden shadow-soft" data-id="element-173" data-mp="2fb4zctjyyy50">
          <div className="p-6 sm:p-10" data-id="element-174" data-mp="2actnyee10fko">
            {packComposition && <div className="mb-8 overflow-hidden rounded-2xl bg-blush" data-id="element-175" data-mp="pl0ehzee64gi">
                <img src={packComposition.src} alt={packComposition.alt} loading="lazy" decoding="async" className="w-full h-auto object-contain" data-id="element-176" data-mp="ujbqogs5sr1w" />
              </div>}
            <ul className="divide-y divide-ink/10" data-id="element-177" data-mp="zj6ci5x2uqg3">
              {allResources.map(r => <li key={r.id} className="flex items-center gap-4 py-3.5 first:pt-0 last:pb-0" data-id="element-178" data-mp="13ip0jak73hn5">
                  <div className="h-16 w-16 shrink-0 rounded-xl overflow-hidden bg-blush" data-id="element-179" data-mp="6v0sxmhrf7hu">
                    {r.image ? <img src={r.image} alt="" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-180" data-mp="btlwnvw809b1" /> : <CoverPending title={r.name} compact data-id="element-181" data-mp="ftm9xd7l2egi" />}
                  </div>
                  <div className="min-w-0" data-id="element-182" data-mp="km5x91w2onyi">
                    <p className="text-xs font-semibold text-berry-deep" data-id="element-183" data-mp="kn8nr8phgodw">{r.label}</p>
                    <p className="font-serif text-base sm:text-lg font-semibold text-plum leading-snug" data-id="element-184" data-mp="3k8dov4kiz1sf">
                      {r.name}
                    </p>
                    {r.kind === 'bonus' && <p className="mt-0.5 text-sm" data-id="element-185" data-mp="vefqjui6rqxe">
                        <s className="text-ink/60" data-id="element-186" data-mp="qgxgu1wch7oc">{siteConfig.bonusOriginalPrice}</s>{' '}
                        <span className="font-semibold text-berry-deep" data-id="element-187" data-mp="155k6awforfta">Gratis inbegrepen</span>
                      </p>}
                  </div>
                </li>)}
            </ul>
          </div>

          <div className="bg-blush p-8 sm:p-10 flex flex-col justify-center text-center" data-id="element-188" data-mp="cgv38rv2l0ew">
            <p className="text-sm font-medium text-ink/75" data-id="element-189" data-mp="cippqalzp0l3">{siteConfig.descriptor}</p>
            <p className="mt-1 text-sm font-medium text-ink/75" data-id="element-190" data-mp="7jwb2euyv3jc">Handleiding + sjablonenverzameling + 4 bonussen</p>
            <p className="mt-2 font-serif text-[2.75rem] sm:text-6xl lg:text-7xl font-semibold text-plum whitespace-nowrap" data-id="element-191" data-mp="lf86ypkuz01u">
              {siteConfig.price}
            </p>
            <p className="mt-3 text-sm text-ink/75" data-id="element-192" data-mp="1wuwsdcigrr0j">Eenmalige betaling · Geen abonnement</p>

            <div className="mt-8" data-id="element-193" data-mp="1sul840u0jspl">
              <a href={siteConfig.checkoutUrl} className={`${ctaClass} hover:bg-berry-darker`} data-id="element-194" data-mp="20engg8v8lcm8">Bestel het pakket</a>
            </div>

            <p className="mt-5 text-[13px] leading-relaxed text-ink/70" data-id="element-195" data-mp="25e0dfmfto02j">
              Dit is een digitaal product. Je ontvangt geen fysieke materialen.
            </p>
          </div>
        </div>
      </div>
    </section>;
}